var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17501_10486)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 17.493V14.8427C22.4994 15.0657 20.9719 14.6984 19.7253 13.8149C18.4788 12.9313 17.6059 11.5972 17.2827 10.0814H22.2859V7.48307H17.2827C17.6045 5.96471 18.476 4.62717 19.7221 3.73913C20.9682 2.85109 22.4965 2.47832 24.0002 2.69571V0.0454582C22.8432 -0.0755321 21.6743 0.0456119 20.5646 0.401516C19.4549 0.757421 18.4276 1.34064 17.5452 2.11568C16.6628 2.89071 15.9438 3.84135 15.4319 4.90972C14.9201 5.9781 14.6261 7.14187 14.5679 8.33018C14.5097 9.5185 14.6884 10.7065 15.0932 11.8219C15.4981 12.9373 16.1206 13.9567 16.9228 14.8182C17.725 15.6796 18.6901 16.365 19.7595 16.8327C20.8289 17.3003 21.9801 17.5405 23.143 17.5384C23.4351 17.5384 23.7208 17.5384 24.0002 17.493Z",
    fill: "#3C6E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.76923C0 11.095 0.903059 13.3255 2.51051 14.97C4.11797 16.6146 6.29815 17.5385 8.57143 17.5385C8.87689 17.5383 9.18211 17.5209 9.48571 17.4865V14.8362C8.63067 14.9709 7.75728 14.9148 6.92543 14.6718C6.09357 14.4287 5.32291 14.0045 4.6663 13.4283C4.00969 12.852 3.48265 12.1373 3.12132 11.3331C2.75999 10.5289 2.57291 9.65431 2.57291 8.76923C2.57291 7.88416 2.75999 7.00955 3.12132 6.20537C3.48265 5.40119 4.00969 4.68647 4.6663 4.11019C5.32291 3.53392 6.09357 3.10973 6.92543 2.86671C7.75728 2.62368 8.63067 2.56757 9.48571 2.70222V0.0519658C9.18206 0.0181969 8.87687 0.000850828 8.57143 0C6.29815 0 4.11797 0.923898 2.51051 2.56845C0.903059 4.213 0 6.44349 0 8.76923",
    fill: "#3C6E8E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17501_10486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 17.5385,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCeLogo);
export default __webpack_public_path__ + "static/media/ce_logo.498901e413d1d3bf2bc31e961a689dcf.svg";
export { ForwardRef as ReactComponent };